export default __webpack_public_path__ + "media/search/map-32828ceb.svg";